/**
 * Sales Component Constants
 * 
 * Centralized constants for the Sales component including view modes,
 * modal types, and permission IDs.
 */

/**
 * Available view modes for the Sales component
 */
export const VIEW_MODES = {
  MESA: 'mesa',
  COMANDAS: 'comandas',
  ORDER: 'order',
  PAYMENT: 'payment',
  CREATE_PEDIDO: 'createPedido',
  RECEIPT: 'receipt',
} as const;

/**
 * ViewMode type derived from VIEW_MODES constant
 */
export type ViewMode = typeof VIEW_MODES[keyof typeof VIEW_MODES];

/**
 * Available modal types for the Sales component
 */
export const MODAL_TYPES = {
  RESET: 'reset',
  MOVE: 'move',
} as const;

/**
 * ModalType type derived from MODAL_TYPES constant, including null for no active modal
 */
export type ModalType = typeof MODAL_TYPES[keyof typeof MODAL_TYPES] | null;

/**
 * Permission IDs used throughout the Sales component
 * 
 * @constant EDIT_ORDER - Permission to edit orders (ID: 121)
 * @constant RESET_TABLE - Permission to reset/empty tables (ID: 122)
 * @constant GENERATE_BILL - Permission to generate bills/precuenta (ID: 129)
 * @constant VIEW_RECEIPT - Permission to view receipts (ID: 2)
 */
export const PERMISSIONS = {
  EDIT_ORDER: 121,
  RESET_TABLE: 122,
  GENERATE_BILL: 129,
  VIEW_RECEIPT: 2,
} as const;

/**
 * Pedido type IDs
 * 
 * @constant RESTAURANT - Restaurant/Table orders (ID: 1)
 * @constant CAJA - Pickup/Counter orders (ID: 2)
 * @constant DELIVERY - Delivery orders (ID: 3)
 */
export const PEDIDO_TYPES = {
  RESTAURANT: 1,
  CAJA: 2,
  DELIVERY: 3,
} as const;

/**
 * Presentation view modes for the restaurant
 */
export const PRESENTATION_MODES = {
  MAPA: 'mapa',
  LISTA: 'lista',
  PEDIDOS: 'pedidos',
} as const;

export type PresentationMode = typeof PRESENTATION_MODES[keyof typeof PRESENTATION_MODES];
